/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, createSearchParams } from 'react-router-dom';
import {
  Box,
  Center,
  Stack,
  Button,
  Title,
  ActionIcon,
  Modal,
  Text,
  Group,
  Divider,
  SimpleGrid,
  Image,
  Paper,
  Loader,
  Space,
} from '@mantine/core';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { w3cwebsocket as W3CWebSocket } from 'websocket';
import { showNotification } from '@mantine/notifications';
import { CircleX } from 'tabler-icons-react';
import { IconX } from '@tabler/icons';
import CarArrow from '../../image/car-arrow.png';
import CarArrowReverse from '../../image/carArrow-reverse.png';
import { sendRequest } from '../../services/services';
import AppContext from '../Context/index';
import PaymentStatus from '../../pages/PosPayment/PaymentStatus';
import PrintInvoice from '../../pages/PosPayment/invoice';
import AlertImg from '../../image/alert.svg';

const TicketSummary = ({ passId, vasBook, name }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const appContextState = useContext(AppContext);
  const { appState } = appContextState;
  const [ticketData, setTicketData] = useState();
  const [cardPay, setCardPay] = useState(false);
  const [errorPos, setErrorPos] = useState(false);
  const [response, setResponse] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [openInvoice, setOpenInvoice] = useState(false);

  const selectedVas = JSON.parse(localStorage.getItem('selectedVas'));
  const siteDetails = JSON.parse(localStorage.getItem('siteDetails'));
  console.log('sss', selectedVas);
  useEffect(() => {
    sendRequest(`parking/reservations-by-pass-id/${passId}`, 'get').then((res) => {
      if (res?.code === 20) {
        setTicketData(res?.data || []);
      } else if (res?.code === 21) {
        showNotification({
          title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
          icon: <IconX size={16} />,
        });
      }
    });
  }, [passId]);

  console.log('datavas', vasBook);

  const cardPayment = () => {
    const wsurl = `ws://localhost:5000/messages`;

    // Init Websocket Client
    const client = new W3CWebSocket(wsurl);
    client.onerror = () => {
      console.log('Connection Error');
    };

    client.onopen = () => {
      console.log('WebSocket Client Connected');

      function connectPort() {
        if (client.readyState === client.OPEN) {
          const comName = siteDetails?.comPortNumber;
          const sendData = JSON.stringify({
            // Event: "CONNECTION",
            // Operation: "CONNECT",
            // IpAddress: "192.168.8.104",
            // ConnectionMode: "TCP",
            // Port: 6100
            Event: 'CONNECTION',
            Operation: 'CONNECT',
            connectionMode: 'COM',
            comName,
            braudRate: '38400',
            dataBits: '8',
            parity: 'none',
          });

          client.send(sendData);
        }
      }

      connectPort();

      function sendAmount() {
        if (client.readyState === client.OPEN) {
          // const amount = ticketData?.result?.invoices?.payable_amount;
          const amount = Math.round(ticketData?.result?.invoices?.payable_amount);
          // const amount = valet;
          const sendAmountData = JSON.stringify({
            Event: 'TRANSACTION',
            Operation: 'PURCHASE',
            Amount: amount,
            PrintSettings: '1',
            AppId: '11',
            ECRNumber: '1234567890123456',
          });
          client.send(sendAmountData);
        }
      }
      sendAmount();
    };

    client.onclose = () => {
      function closePort() {
        if (
          paymentStatus?.TransactionResponseEnglish ||
          paymentStatus?.TransactionResultReasonEnglish === 'APPROVED'
        ) {
          const sendData = JSON.stringify({
            Event: 'CONNECTION',
            Operation: 'DISCONNECT',
          });
          client.send(sendData);
        }
      }
      closePort();
      console.log('echo-protocol Client Closed');
    };

    client.onmessage = (message) => {
      if (typeof message.data === 'string') {
        // console.log('Received', message.data);
        setResponse(JSON.parse(message?.data));
      }
    };
    if (ticketData?.result?.invoices?.invoice_status?.name === 'paid') {
      setCardPay(true);
    }
  };

  useEffect(() => {
    if (response?.TerminalAction === 'SWIPE_OR_INSERT') {
      setCardPay(true);
    } else if (response?.TerminalAction === 'IDLE_SCREEN') {
      setCardPay(false);
    } else if (response?.EventName === 'TERMINAL_RESPONSE') {
      setPaymentStatus(JSON.parse(response?.JsonResult));
    } else if (
      paymentStatus?.TransactionResponseEnglish ||
      paymentStatus?.TransactionResultReasonEnglish === 'Decline'
    ) {
      setPaymentStatus();
    }
  }, [
    paymentStatus?.TransactionResponseEnglish,
    paymentStatus?.TransactionResultReasonEnglish,
    response?.EventName,
    response?.JsonResult,
    response?.TerminalAction,
  ]);

  useEffect(() => {
    if (response?.TerminalAction === 'SWIPE_OR_INSERT') {
      setCardPay(true);
    } else if (response?.TerminalAction === 'IDLE_SCREEN') {
      setCardPay(false);
    } else if (response?.EventName === 'TERMINAL_RESPONSE') {
      setPaymentStatus(JSON.parse(response?.JsonResult));
    }
  }, [response, ticketData?.result?.invoices?.invoice_status?.name]);
  const now = dayjs();
  const date1 = dayjs(ticketData?.result?.start_time);
  const date2 = dayjs(
    !ticketData?.result?.end_time
      ? now
      : !ticketData?.result?.tickets?.exit_time
      ? ticketData?.result?.end_time
      : ticketData?.result?.tickets?.exit_time,
  );
  const TotalSeconds = date2.diff(date1, 'minutes');
  const hours = Math.ceil(TotalSeconds / 60);
  const startDate = dayjs(ticketData?.result?.start_time).format('DD-MM-YYYY HH:mm').slice(0, -5);
  const startTime = dayjs(ticketData?.result?.start_time).format('DD-MM-YYYY HH:mm').slice(10);

  const endDate = dayjs(
    ticketData?.result?.tickets?.ticket_status_types?.id === 3
      ? ticketData?.result?.tickets?.exit_time
      : !ticketData?.result?.end_time
      ? now
      : ticketData?.result?.end_time,
  )
    .format('DD-MM-YYYY HH:mm')
    .slice(0, -5);
  const endTime = dayjs(
    ticketData?.result?.tickets?.ticket_status_types?.id === 3
      ? ticketData?.result?.tickets?.exit_time
      : !ticketData?.result?.end_time
      ? now
      : ticketData?.result?.end_time,
  )
    .format('DD-MM-YYYY HH:mm')
    .slice(10);
  console.log('mkkk', endDate);

  const detailsPage = () => {
    navigate({
      pathname: '/services',
      search: createSearchParams({
        numberplate: ticketData?.result?.vehicles?.number_plate,
        tax: ticketData?.result?.invoices?.tax,
        passId,
      }).toString(),
    });
  };

  useEffect(() => {
    const body = {
      pass_id: passId,
      vas: selectedVas,
    };
    if (selectedVas) {
      sendRequest(`/parking/add-on-services`, 'patch', body)
        .then(({ code, msg }) => {
          if (code === 20) {
            sendRequest(`parking/reservations-by-pass-id/${passId}`, 'get').then((res) => {
              setTicketData(res?.data || []);
            });
            localStorage.removeItem('selectedVas');
            console.log('success');
          } else if (code === 40) {
            showNotification({
              title: <Text weight={500}>{msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            showNotification({
              title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        });
    }
  }, []);
  return (
    <Box className="no-printme">
      <Paper shadow="lg" withBorder p="xl">
        <Stack>
          <Group position="apart">
            <Text size="sm" weight={500} color="#817E7E">
              {t('ticket.welcome')} :
              {ticketData?.result?.guest_users === null && ticketData?.result?.customers === null
                ? name || t('ticket.guest')
                : ticketData?.result?.guest_users === null
                ? ticketData?.result?.customers?.full_name
                : ticketData?.result?.customers === null
                ? ticketData?.result?.guest_users?.first_name
                : t('ticket.guest')}
            </Text>
            {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
              <Text size="xl" weight={700} color="green">
                {t('status.paid')}
              </Text>
            ) : null}
            <Text size="sm" weight={500} color="#817E7E">
              {t('ticket.plate.number')} : {ticketData?.result?.vehicles?.number_plate}
            </Text>
          </Group>

          <Group position="apart" style={{ marginBottom: '-20px' }}>
            <Group>
              <Stack>
                <Center>
                  <Title size="sm" order={2}>
                    {t('ticket.entry.text')}
                  </Title>
                </Center>
                <Center style={{ marginBottom: '-18px' }}>
                  <Text size="sm" weight={500}>
                    {startDate}
                  </Text>
                </Center>
                <Center>
                  <Text size="sm" weight={500}>
                    {startTime}
                  </Text>
                </Center>
              </Stack>
            </Group>
            {appState?.language === 'ar' ? (
              <Image src={CarArrowReverse} />
            ) : (
              <Image src={CarArrow} />
            )}
            <Group>
              <Stack>
                <Center>
                  <Title size="sm" order={2}>
                    {t('ticket.exit.text')}
                  </Title>
                </Center>
                <Center style={{ marginBottom: '-18px' }}>
                  <Text size="sm" weight={500}>
                    {endDate}
                  </Text>
                </Center>
                <Center>
                  <Text size="sm" weight={500}>
                    {endTime}
                  </Text>
                </Center>
              </Stack>
              <ActionIcon
                color="dark"
                size="xl"
                radius="xl"
                variant="default"
                sx={{
                  borderColor: 'black',
                  width: '80px',
                  height: '80px',
                  borderRadius: '50px',
                }}
              >
                <Text weight={900} size="lg">
                  {hours} {t('ticket.hours.text')}
                </Text>
              </ActionIcon>
            </Group>
          </Group>
          <Space h="xs" />
          <Group position="apart">
            <Stack>
              <Title size="sm" order={2}>
                {t('ticket.description.text')}
              </Title>
              <Text weight={500} color="#817E7E">
                {hours} {t('ticket.hours.parking.text')}
              </Text>
              {ticketData?.result?.vas_orders.map((item) => (
                // <Text size="sm" weight={500} color="#817E7E">
                //   {item?.vas_types?.name}
                // </Text>
                <div>
                  {appState?.language === 'en' ? (
                    <Text weight={500} color="#817E7E">
                      {item?.vas_types?.name} | {item?.vas_sub_types?.name} X {item?.qty}
                    </Text>
                  ) : (
                    <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                      {item?.vas_types?.name === 'Trolley' ? (
                        <Text weight={500} color="#817E7E">
                          {t('choose.service.trolly.title.text')}
                        </Text>
                      ) : item?.vas_types?.name === 'Car Wash' ? (
                        <Text weight={500} color="#817E7E">
                          {t('choose.service.carwash.title.text')}
                        </Text>
                      ) : (
                        <Text weight={500} color="#817E7E">
                          {t('choose.service.shuttle.title.text')}
                        </Text>
                      )}
                    </Group>
                  )}
                </div>
              ))}
              {/* <Text size="sm" weight={500} color="#817E7E">
              {t('ticket.tax.text')}
            </Text> */}
            </Stack>

            <Stack>
              <Title size="sm" order={2}>
                {t('ticket.amount.text')}
              </Title>
              <Text weight={500} color="#817E7E">
                {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                  ? 0
                  : (Number(ticketData?.result?.amount) * hours).toFixed(2)}{' '}
                {t('ticket.amount.sar.text')}
              </Text>

              {ticketData?.result?.vas_orders.map((item) => (
                <Text weight={500} color="#817E7E">
                  {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                    ? 0
                    : (Number(item?.amount) * Number(item?.qty)).toFixed(2)}{' '}
                  {t('ticket.amount.sar.text')}
                </Text>
              ))}
              {/* <Text size="sm" weight={500} color="#817E7E">
              {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                ? 0
                : ticketData?.result?.invoices?.tax}{' '}
              {t('ticket.amount.sar.text')}
            </Text> */}
            </Stack>
          </Group>

          <Divider size="sm" />
          <Group position="apart">
            <Stack>
              <Title size="sm" color="dimmed" order={6}>
                {t('ticket.tax.text')}(15%)
              </Title>
              <Title size="sm" order={2}>
                {t('ticket.amount.total.text')}
              </Title>
            </Stack>
            <Stack px="xl">
              <Title size="sm" color="dimmed" order={6} style={{ marginLeft: '13px' }}>
                {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                  ? 0
                  : ticketData?.result?.invoices?.tax.toFixed(2)}{' '}
                {t('ticket.amount.sar.text')}
              </Title>
              <Title size="sm" color="blue.5" order={2} px="xs">
                {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                  ? 0
                  : ticketData?.result?.invoices?.payable_amount.toFixed(2)}{' '}
                {t('ticket.amount.sar.text')}
              </Title>
            </Stack>
          </Group>

          <Group position="apart">
            <SimpleGrid cols={2} sx={{ width: '100%' }}>
              {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
                <Button
                  // onClick={posPayment}
                  // onClick={cardPayment}
                  onClick={() => setOpenInvoice(true)}
                  sx={{ backgroundColor: '#01AA84', width: '100%' }}
                  size="xl"
                  // disabled={ticketData?.result?.invoices?.invoice_status?.name === 'paid'}
                >
                  {t('payment.status.invoice.print.invoice.button.text')}
                </Button>
              ) : (
                <Button
                  // onClick={posPayment}
                  onClick={cardPayment}
                  sx={{ backgroundColor: '#01AA84', width: '100%' }}
                  size="xl"
                  // disabled={ticketData?.result?.invoices?.invoice_status?.name === 'paid'}
                >
                  {t('ticket.amount.pay.button.text')}
                </Button>
              )}
              <Button
                onClick={detailsPage}
                sx={{ backgroundColor: '#34B3F1', width: '100%' }}
                size="xl"
                disabled={ticketData?.result?.invoices?.invoice_status?.name === 'paid'}
              >
                {t('ticket.amount.other.service.button.text')}
              </Button>
            </SimpleGrid>
          </Group>
        </Stack>
      </Paper>

      <Modal
        opened={cardPay}
        // onClose={() => cardPayment(false)}
        withCloseButton={false}
        centered
        size="90%"
        // title={<Text p="xl">You want to end the shift</Text>}
      >
        <Center>
          {paymentStatus?.TransactionResponseEnglish === 'APPROVED' ||
          ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
            <PaymentStatus
              invoiceDataId={ticketData?.result?.invoices?.id}
              passDataId={
                ticketData?.result?.passId === undefined ? passId : ticketData?.result?.passId
              }
            />
          ) : (
            <Center>
              {response?.TerminalAction === 'SWIPE_OR_INSERT' ? (
                <Stack>
                  <Title order={1}>Swipe or Insert</Title>
                  <Center>
                    <Title order={1}>Card</Title>
                  </Center>
                </Stack>
              ) : (
                <div>
                  {response?.TerminalAction === 'USER_CANCELLED_AND_TIMEOUT' ? (
                    <Stack>
                      <Title order={1}>Cancel or Timeout</Title>
                    </Stack>
                  ) : (
                    <div>
                      {response?.TerminalStatus === 'BUSY' ? (
                        <Stack>
                          <Title order={1}>Payment Processing</Title>
                          <Loader variant="dots" />
                        </Stack>
                      ) : paymentStatus?.TransactionResponseEnglish === 'DECLINED' ? (
                        <Stack>
                          <Title order={1}>Card Declined</Title>
                        </Stack>
                      ) : null}
                    </div>
                  )}
                </div>
              )}
            </Center>
          )}
        </Center>
      </Modal>
      <Modal opened={errorPos} onClose={() => setErrorPos(false)} centered size="50%">
        <Center>
          <Image src={AlertImg} width={100} />;
        </Center>
        <Center py="xl">
          <Title order={1}>Error with Connection</Title>
        </Center>
      </Modal>
      <Modal opened={openInvoice} withCloseButton={false} centered size="xl">
        <PrintInvoice invoiceDataId={ticketData?.result?.invoices?.id} passDataId={passId} />
      </Modal>
    </Box>
  );
};
export default TicketSummary;
